import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { userDetails, authLoading } = useContext(AuthContext);

  if (authLoading) return null;

  if (!userDetails) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;